module.exports = "<header class=\"{{path}}\">\n  <img src=\"assets/logo.png\" />\n</header>\n"